import React from "react";
import { Scale, FileText, AlertTriangle } from "lucide-react";
import { LegalLayout, LegalSection, CheckList } from "./legal/LegalLayout";

const TermsOfService = () => (
  <LegalLayout
    eyebrow="Legal Terms"
    eyebrowIcon={Scale}
    title="Terms of Service"
    subtitle="Professional terms governing our Virtual Guard services for HOA communities and residential properties."
    updated="Last Updated: January 2025"
  >
    <div className="space-y-6">
      <LegalSection icon={FileText} title="Service Agreement">
        <p>By using Redline Monitoring Services Inc.'s Virtual Guard services or requesting consultations, you agree to these Terms of Service. Our dedicated Virtual Guards provide remote monitoring services exclusively to your property from our secure command center.</p>
        <p>Redline Monitoring Services Inc. is a licensed security company (Texas DPS License #B30959201) specializing in virtual security solutions for HOA communities, residential gates, and property protection.</p>
      </LegalSection>

      <LegalSection title="Virtual Guard Services">
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-3">Service Scope</h3>
          <p className="mb-4">Our Virtual Guard services include:</p>
          <CheckList items={[
            "Dedicated Virtual Guard assigned exclusively to your property",
            "Remote monitoring from our command center",
            "Camera installation and license plate reader systems",
            "Security reporting dashboard with daily/weekly/monthly reports",
            "Gate access management and cluster mailbox protection solutions",
          ]} />
        </div>
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-3">Service Limitations</h3>
          <p>Virtual Guard services are remote monitoring services. We do not provide on-site physical security personnel. Response to incidents involves coordination with local law enforcement and emergency services as appropriate.</p>
        </div>
      </LegalSection>

      <LegalSection title="Client Responsibilities">
        <CheckList color="blue" items={[
          "Provide accurate property information and access requirements",
          "Maintain proper internet connectivity for camera and monitoring systems",
          "Ensure electrical power availability for security equipment",
          "Notify Redline of changes affecting security monitoring requirements",
          "Comply with payment terms and service agreements",
        ]} />
      </LegalSection>

      <LegalSection icon={AlertTriangle} title="Important Disclaimers" tone="warn">
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-2">Service Limitations</h3>
          <p>Virtual Guard services cannot prevent all security incidents. Our services are designed to provide monitoring, deterrence, and rapid response coordination. We cannot guarantee prevention of all criminal activity or incidents.</p>
        </div>
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-2">Technology Dependencies</h3>
          <p>Service effectiveness depends on internet connectivity, electrical power, and proper functioning of security equipment. Service interruptions may occur due to technical failures, weather, or circumstances beyond our control.</p>
        </div>
        <div>
          <h3 className="font-semibold text-[#1A1A1A] mb-2">Liability Limitation</h3>
          <p>Redline Monitoring Services Inc.'s liability is limited to the monthly service fees paid. We maintain professional liability insurance as required by Texas DPS regulations but cannot accept liability for property damage or losses beyond our direct control.</p>
        </div>
      </LegalSection>

      <LegalSection title="Questions About Terms?" tone="accent">
        <p>Contact us for clarification on these Terms of Service:</p>
        <p className="font-semibold text-white">mike@redlinemonitoring.com&nbsp;&nbsp;|&nbsp;&nbsp;(512) 363-6584</p>
      </LegalSection>
    </div>
  </LegalLayout>
);

export default TermsOfService;
